import { RoleName } from "@/enum/roles.enum"
import { request } from "../utils/request"

/**
 * 登录接口
 * @param data 
 * @returns 
 */
export const login = (data: { username: string, password: string }) => {
    return request.post('/auth/login', data)
}

/**
 * 退出登录
 * @returns 
 */
export const logout = () => {
    return request.post('/auth/logout')
}

/**
 * 获取登录后用户基本信息
 * 
 * 添加用户角色中文名称
 * 
 * @returns 
 */
export const getUserProfile = (): Promise<any> => {
    return new Promise((resolve) => {
        request.get('/user/profile').then((res) => {
            res.data.roleName = RoleName[res.data.role]
            return resolve(res);
        })
    })
}


/**
 * 获取用户分页数据
 * 
 * 获取的数据添加角色中文名称
 * 
 * @param params 
 * @returns 
 */
export const getUsers = (params: { page: number, limit: number }): Promise<any> => {
    return new Promise((resolve) => {
        request.get('/user', { params }).then((res) => {
            res.data.result.forEach((user: { [x: string]: any; role: string }) => {
                user['roleName'] = RoleName[user.role]
            })
            return resolve(res)
        })
    })
}

/**
 * 新建用户
 * @param data 
 * @returns 
 */
export const createUser = (data: { name: string, cellphone: string | null, role: string, password: string, company: number | null, project: number | null }) => {
    return request.post('/user/create', data)
}

/**
 * 更新用户信息
 * @param data 
 * @returns 
 */
export const updateUser = (data: { id: number; name: string, cellphone: string | null, role: string, company: number | null, project: number | null }) => {
    return request.post('/user/update', data)
}

/**
 * reset 清楚用户绑定关系
 * @param data 
 * @returns 
 */
export const resetUser = (data: { id: number | undefined }) => {
    return request.post('/user/reset', data)
}

/**
 * 更新密码接口
 * @param data 
 * @returns 
 */
export const resetPswd = (data: { newPswd: string, oldPswd?: string, id?: number }) => {
    return request.post('/user/update/password', data)
}
